// extracted by mini-css-extract-plugin
export default {"mainContainer":"Footer_mainContainer__81f+f","textContent":"Footer_textContent__bvcnC"};